module.exports = __webpack_public_path__ + "img/8fb6dc2.png";